import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import { Url } from '@wix/da-url';
import { useTranslation } from 'react-i18next';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import HiddenIcon from '@wix/da-ds/pkg/Icons/32x32/Hidden';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import HiddenLayout from './HiddenLayout';
import { BiData } from '@wix/da-bi/pkg/events';
const MatureAnonymousBlockedOverlay = (props)=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(HiddenLayout, _object_spread({
        icon: /*#__PURE__*/ React.createElement(HiddenIcon, {
            size: IconSize.HUGE
        }),
        text: t('deviationview.blocked.mature.text'),
        button: /*#__PURE__*/ React.createElement(GhostButton, {
            variant: "main",
            size: "medium",
            href: Url.joinLink('mature'),
            biData: BiData({
                evid: 240,
                referral_info: ReferralType.MATURE
            })
        }, t('deviationview.blocked.nsfg.anon.signIn'))
    }, props));
};
MatureAnonymousBlockedOverlay.displayName = 'MatureAnonymousBlockedOverlay';
export default MatureAnonymousBlockedOverlay;

//# sourceMappingURL=MatureAnonymousBlocked.js.map